import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SalesModuleApiSuffixModels, loggedInUserData } from '@app/modules';
import { AppState } from '@app/reducers';
import {
    CrudService,
    IApplicationResponse, LoggedInUserModel, ModulesBasedApiSuffix,
    RxjsService,
    formConfigs
} from '@app/shared';
import { Store } from '@ngrx/store';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';
import { combineLatest } from 'rxjs';
@Component({
    selector: 'quote-decline-pop-up',
    templateUrl: './quote-decline-pop-up.component.html'
})

export class QuoteDeclinePopUpComponent implements OnInit {
    formConfigs = formConfigs;
    declinedReasonAddEditForm: FormGroup;
    loggedInUserData: LoggedInUserModel;
    outComeReasons = [];
    data;

    constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig,
        private crudService: CrudService,
        private formBuilder: FormBuilder,
        private store: Store<AppState>, private rxjsService: RxjsService) {
        this.data = config?.data;
    }

    ngOnInit(): void {
        this.rxjsService.setDialogOpenProperty(true);
        this.combineLatestNgrxStoreData();
        this.crudService.get(
            ModulesBasedApiSuffix.SALES,
            SalesModuleApiSuffixModels.SALES_API_UX_OUTCOME_REASON,
            this.data.selectedOutcomeId, false, null).subscribe((response: IApplicationResponse) => {
                if (response.isSuccess && response.statusCode === 200 && response.resources) {
                    this.outComeReasons = response.resources;
                }
                this.rxjsService.setPopupLoaderProperty(false);
            });
        this.declinedReasonAddEditForm = this.formBuilder.group({
            outcomeReasonId: ['', Validators.required],
            comments: ['']
        });
    }

    combineLatestNgrxStoreData() {
        combineLatest([this.store.select(loggedInUserData)]).subscribe((response) => {
            this.loggedInUserData = new LoggedInUserModel(response[0]);
        });
    }

    onSubmit(): void {
        if (this.declinedReasonAddEditForm.invalid) return;
        this.declinedReasonAddEditForm.value.outcomeId = this.data.selectedOutcomeId;
        this.declinedReasonAddEditForm.value.createdUserId = this.loggedInUserData.userId;
        this.declinedReasonAddEditForm.value.quotationVersionId = this.data.quotationVersionId;
        this.crudService.create(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.SALES_API_QUOTATION_OUTCOME_DECLINE, this.declinedReasonAddEditForm.value, 1).subscribe((response) => {
            if (response.isSuccess && response.statusCode === 200) {
                this.ref.close({ isSubmitted: true });
                this.declinedReasonAddEditForm.reset();
            }
        });
    }

    dialogClose(): void {
        this.ref.close(false);
    }

    ngOnDestroy(): void {
        this.rxjsService.setDialogOpenProperty(false);
    }
}
